module.exports = __webpack_public_path__ + "img/pc-toc-code.8e76133b.jpeg";